import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Dot.styles';

const Dot = ({ variant, modifier }) => (
  <S.Dot variant={variant} modifier={modifier} />
);

Dot.defaultProps = {
  modifier: 'regular',
  variant: 'neutral',
};

Dot.propTypes = {
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted'])
    .isRequired,
  variant: PropTypes.oneOf(['danger', 'info', 'warning', 'success', 'neutral'])
    .isRequired,
};

export default Dot;
